import { Component, Input } from '@angular/core';

import { IconPosition } from '../../new-button.component';

@Component({
  selector: 'broker-button-refresh-svg',
  templateUrl: './refresh-svg.component.svg'
})
export class RefreshSvgComponent {
  @Input() position: IconPosition = 'left';
}
